function initQuery(app) {
  if (window.location.search != "") {
    let search = window.location.search.replace("?", "").split("&");
    search.forEach((el) => {
      let split = el.split("=");
      app.query[split[0]] = split[1];
    });
  }
}

export default initQuery
